import { Button, ButtonGroup } from "@shopify/polaris";
import { useCallback } from "react";
import { ANNUAL, EVERY_30_DAYS } from "../../../../../constants/subscriptionInterval.js";

const ChangePriceButtons = ({ subscriptionInterval, setSubscriptionInterval }) => {

  const handleFirstButtonClick = useCallback(() => {
    if (subscriptionInterval === EVERY_30_DAYS) {
      return;
    }
    setSubscriptionInterval(EVERY_30_DAYS);
  }, [subscriptionInterval, setSubscriptionInterval]);

  const handleSecondButtonClick = useCallback(() => {
    if (subscriptionInterval === ANNUAL) {
      return;
    }
    setSubscriptionInterval(ANNUAL);
  }, [subscriptionInterval, setSubscriptionInterval]);

  return (
    <ButtonGroup segmented>
      <Button pressed={subscriptionInterval === EVERY_30_DAYS} onClick={handleFirstButtonClick}>
        Monthly
      </Button>
      <Button pressed={subscriptionInterval === ANNUAL} onClick={handleSecondButtonClick}>
        Yearly (Extra 10% OFF!)
      </Button>
    </ButtonGroup>
  );
};

export default ChangePriceButtons;